import { create } from 'zustand';

// slice 02.1 · c.2 — `taskFilterUsers` out of `UserContext` (README §1.5). Was a `useState` +
// a fetch-on-mount effect + a POST-back-on-change callback living in `UserProvider`, read by
// every consumer through `useUser()` even though most renders never touch it. Only 2 real
// consumers today (`ComponentTask.jsx`, `ComponentTaskHoy.jsx`, both tasks feature) — the
// plan's original "tasks/calendar/mail/dapps" note didn't hold up: `ComponentCalendar.jsx`
// destructured it from `useUser()` but never used it (dead read, removed in this same commit).
//
// `hydrated` lives in the store itself (not a per-component ref) so it stays a true
// hydrate-once regardless of how many components call `useTaskFilterUsers()`.
export const useTaskFilterStore = create((set, get) => ({
    users: [],
    hydrated: false,
    setUsers: (updater) => set((state) => ({
        users: typeof updater === 'function' ? updater(state.users) : updater,
    })),
    hydrate: async (dbId) => {
        if (!dbId || get().hydrated) return;
        set({ hydrated: true });
        try {
            const res = await fetch(`/api/customs/${dbId}/task_filter_users`);
            const data = await res.json();
            if (data.success && Array.isArray(data.value)) {
                set({ users: data.value });
            }
        } catch (err) {
            console.error('Error loading custom filters', err);
        }
    },
}));
